module.exports = __webpack_public_path__ + "static/lesson_1-8a241cb491e3d060a0bd4a22b9e479b6.png";